export default {"src":"/_next/static/media/outlook.bb969623.svg","height":2500,"width":2457,"blurWidth":0,"blurHeight":0};